import { useQuery } from '@tanstack/react-query';

import { ERROR_CODES } from '@constants/errors';
import { QUERY_KEYS } from '@constants/query-keys';
import { getPromotions } from '@services/PromotionsService';

import type {
  IPromotionsResponse,
  QueryClient,
  ReactQueryOptions
} from 'types';

export function usePromotions(queryOptions: ReactQueryOptions<IPromotionsResponse> = {}) {
  return useQuery({
    queryKey: getKey(),
    queryFn: () => getPromotions(),
    ...queryOptions
  });
}

function getKey() {
  return [QUERY_KEYS.PROMOTIONS];
}

export async function prefetchPromotions(
  queryClient: QueryClient
) {
  try {
    const promotions = await queryClient.fetchQuery({
      queryKey: getKey(),
      queryFn: () => getPromotions()
    });
    return promotions;
  } catch (err) {
    if (err?.response?.status === ERROR_CODES.NOT_FOUND) {
      return false;
    }
  }
}
